"use client";

import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  Button,
} from "@oreme/ui";
import { MessageCircleQuestion } from "lucide-react";

function GlobalFeedback(): ReactElement {
  const t = useTranslations("global.Feedback");
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            variant="outline"
            aria-label={t("action")}
            className="rounded-full"
            asChild
          >
            <a href={t("url")} target="_blank" aria-label={t("action")}>
              <MessageCircleQuestion strokeWidth={1} />
            </a>
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("action")}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export { GlobalFeedback };
